//import { JaaSMeeting } from "@jitsi/react-sdk";
import { JaaSMeeting, JitsiMeeting } from "@jitsi/react-sdk";
import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { useUser, useVideoCall } from "../../hooks";
import { useParams } from "react-router-dom";
import { Breadcrumbs } from "../../components/breadCrumbs/Breadcrumbs";

export default function VideoCallPage() {
  //Id of patient selected
  const { id } = useParams();
  const { user } = useUser(id);

  //Id of user on the web
  const userData = JSON.parse(sessionStorage.getItem("user"));
  const userName = userData.name;

//  const roomName = "ConsultaDe" + user?.name + "Con" + userName;
//  const roomName = "ConsultaDe" + user?.name.replace(/[^a-zA-Z ]/g, "") + "Con" + userName;

//replace(/[^a-zA-Z ]/g, "") --> remove Non-letters from string
//replace(/[^a-zA-Z]/g, "") --> remove Non-letters AND SPACES from string

  const roomName = "ConsultaDe" + user?.name.replace(/[^a-zA-Z]/g, "") + "Con" + userName.replace(/[^a-zA-Z]/g, "");

//  const roomName = "Consulta de " + user?.name + " con " + userName;
//  const roomName = "MUNCHFIT"+Array.apply(0, Array(6)).map(function() {
/*  const roomName = Array.apply(0, Array(16)).map(function() {
    return (function(charset){
        return charset.charAt(Math.floor(Math.random() * charset.length))
//    }('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'));
    }('ABCDEFGHIJKLMNOPQRSTUVWXYZ'));
  }).join('')
*/
//  const videocallResponse = useVideoCall({ room: roomName, msg_user_id: id });
//  const videocallResponse = useVideoCall({ room: roomName, domain:"https://pre.backend.eatme.cloud:9443",msg_user_id: id });
  const videocallResponse = useVideoCall({ room: roomName, domain:"https://backend.munchfit.app:9443",msg_user_id: id });

  return (
    <LeftSideMenu active="consultation">
      <Breadcrumbs />
      <div id="wrapper">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className="card-box card-tabs m-t-20">
                <h4 className="header-title m-t-0 m-b-30 pull-right">
                  VIDEOLLAMADA
                </h4>

                <div id="tabCall">
                  {user && (
                   /* <JaaSMeeting*/
		    <JitsiMeeting
                      appId={"YOUR_APP_ID"}
                      /*                     roomName="PleaseUseAGoodRoomName"
                       */ roomName={roomName}
			domain = { "backend.munchfit.app:9443" }
                      useStaging={false}
                      getIFrameRef={(node) => (node.style.height = "800px")}
                      configOverwrite={{
                        hiddenPremeetingButtons: ["invite", "settings"],
                        prejoinPageEnabled: false,
                      }}
                      userInfo={{
                        displayName: userData?.name,
                        email: userData?.email,
                      }}
                      onApiReady={async (api) => {
                        console.log(api._url);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}
